import React, { useState, useEffect, memo } from 'react'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import InputRange from 'react-input-range'
import { useTranslation } from 'react-i18next'

import Dropdown from '../dropdown'
import { ITour, IDistanceToNearestTourQueryVariables, DistanceToNearestTourQuery, IDistanceToNearestTourQueryData, withAppStoreValue, AppStoreDispatchAction, EAppActionTypes } from '../../store'
import { ICategoryNavItem, toTourCategory } from '../../store/global/tourCategories';
import { useQuery } from 'react-apollo-hooks';

interface INearByButtonExtraProps {
    topCategory: ICategoryNavItem
    tour: ITour
    isActive: boolean
}

interface INearByButtonAppStoreProps {
    dispatch: AppStoreDispatchAction
}

const NearByButton = memo(withRouter((props: RouteComponentProps & INearByButtonAppStoreProps & INearByButtonExtraProps) => {
    const { t, i18n: { languages: [language] } } = useTranslation();
    const [show, setShow] = useState(false)
    const [distance, setDistance] = useState(25)
    const { location, dispatch, topCategory, tour, isActive } = props
    const { name, icon, filter } = topCategory

    const { data, loading } = useQuery<IDistanceToNearestTourQueryData, IDistanceToNearestTourQueryVariables, any>(DistanceToNearestTourQuery, {
        variables: {
            where: {
                center: {
                    lat: tour.lat,
                    lng: tour.lng
                },
                exclude: [tour.id],
                ...filter
            }
        }
    })

    useEffect(() => {
        if (data && data.distanceToNearestTour > distance) {
            setDistance(Math.max(1, Math.round(data.distanceToNearestTour)+1))
        }
    }, [data])
    
    if (loading || !data || !data.distanceToNearestTour || data.distanceToNearestTour > 99) return null
    const minDistance = Math.max(1, Math.round(data.distanceToNearestTour)+1)

    const handleReset = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault()
        setDistance(Math.max(25, minDistance))
    }

    const onShowClick = () => {
        setShow(false)
        dispatch({ type: EAppActionTypes.SetSelectedTopCategory, selectedTopCategory: toTourCategory(topCategory)})
        dispatch({ type: EAppActionTypes.SetFilter, filter })
    }
    const pathname = `/${language}/${tour.country.slug}/${tour.location.regionSlug}/${tour.location.citySlug}/${tour.slug}/nearby`
    return (
        <Dropdown
            buttonElements={
                <a href="/" onClick={e => e.preventDefault()} className={isActive ? "active nav-item" : "nav-item"}><img src={icon} alt={name} />
                                {t(name)}</a>
            }
            dropdownContent={
                <div className="near-by-picker">
                    <div className="near-by-picker-input">
                        <h6 className={'clearfix'}>{t('Near By')} <small className="fr">Max. {distance}km</small></h6>
                        <InputRange
                            maxValue={99}
                            minValue={minDistance}
                            value={Math.max(distance, minDistance)}
                            onChange={value => setDistance(value as number)}
                        />
                    </div>
                    <div className="near-by-picker-action clearfix">
                        <a href="/" onClick={handleReset} className="cta cta-back cta-small">{t('Reset')}</a>
                        <Link replace={location.pathname === pathname} to={{
                            pathname,
                            state: {
                                nearByTour: {
                                    distance,
                                    tour,
                                    preSelectedTopCategory: topCategory
                                }
                            }
                        }} className="cta fr cta-small" onClick={onShowClick}>{t('Show')}</Link>
                    </div>
                </div>
            }
            showMenu={show}
            setShowMenu={setShow}
        />
    )
}))

export default withAppStoreValue<INearByButtonAppStoreProps, INearByButtonExtraProps>(NearByButton, ['dispatch'])